var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.281,
    height: 17.281,
    viewBox: "0 0 17.281 17.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(-2.946 -2.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M20.228,19.324,15.4,14.5a7.043,7.043,0,1,0-.9.9l4.827,4.827ZM4.248,10A5.753,5.753,0,1,1,10,15.753,5.753,5.753,0,0,1,4.248,10Z",
    transform: "translate(0 0)",
    fill: "#00a3ae"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.81c843ac8b2b865ecf51c2dcdbece8e0.svg";
export { ForwardRef as ReactComponent };